import Send from '../send';

const DEFAULT_API = '/v1/file-info';
export default {

    getFileInfo(fileCategory) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'GET',
            params : {
                fileCategory : fileCategory
            }
        });
    },

    createFileInfo(fileCategory, files) {
        let formData = new FormData();
        formData.append('fileCategory', fileCategory);
        files.map(row=> ( formData.append('files', row) ))
        return Send({
            url : `${DEFAULT_API}`,
            method : 'POST',
            headers: {
                'content-type': 'multipart/form-data'
            },
            data : formData
        });
    },

    deleteFileInfo(fileInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/${fileInfoSeq}`,
            method : 'DELETE',
        });
    }
}